import { checkGate } from '@eventbrite/statsig';
import { BoostTrial } from '../types';
import * as CoreTrialsClient from './CoreTrialsClient';
import * as TonedenTrialsClient from './TonedenTrialsClient';

export const getBoostTrialShadow = async (
    activeOrganizationId?: string,
): Promise<BoostTrial> => {
    try {
        if (activeOrganizationId) {
            const trials = await CoreTrialsClient.getTrials(
                activeOrganizationId,
            );
            console.log(trials);
        } else {
            throw new Error(
                '[getBoostTrial]: Organization ID is not provided.',
            );
        }
    } catch (error) {
        console.error(error);
    }

    return TonedenTrialsClient.getBoostTrial();
};

export const startBoostTrialShadow = async (
    trialVersion: string,
    activeOrganizationId?: string,
) => {
    try {
        if (activeOrganizationId) {
            const trial = await CoreTrialsClient.startTrial(
                activeOrganizationId,
            );
            console.log(trial);
        } else {
            throw new Error(
                '[startBoostTrial]: Organization ID is not provided.',
            );
        }
    } catch (error) {
        console.error(error);
    }

    return TonedenTrialsClient.startBoostTrial(trialVersion);
};

// https://console.statsig.com/7n3hq8N8FgwqPLIkQ9P62X/gates/boost_trial_service_gate
const GATE_NAME = 'boost_trial_service_gate';

export const getBoostTrial = async (
    activeOrganizationId?: string,
): Promise<BoostTrial> => {
    return checkGate(GATE_NAME)
        ? getBoostTrialShadow(activeOrganizationId)
        : TonedenTrialsClient.getBoostTrial();
};

export const startBoostTrial = async (
    trialVersion: string,
    activeOrganizationId?: string,
) => {
    return checkGate(GATE_NAME)
        ? startBoostTrialShadow(trialVersion, activeOrganizationId)
        : TonedenTrialsClient.startBoostTrial(trialVersion);
};
